import React, { useState, useEffect } from "react";
import bsBreakpoints from "bs-breakpoints";
import classNames from "classnames";
import { AiFillFilePdf } from "react-icons/ai";
import PageSection from "../PageSection/PageSection";
import ResponsivePageHeader from "../ResponsivePageHeader/ResponsivePageHeader";
import CustomIcon from "../CustomIcon/CustomIcon";
import { Col, Row, Table } from "react-bootstrap";
import AboutUsMiniCard from "../AboutUsMiniCard/AboutUsMiniCard";
import { studentCellData } from "../../static-data/studentcell.data";
import ClubCard from "../ClubCard/ClubCard";


const StudentCellResponsive = () => {
	const [currentBreakPoint, setCurrentBreakPoint] = useState("");

	const descriptionClasses = classNames("text-center mb-4 text-text-color", {
		"font-sm": currentBreakPoint === "xSmall" || currentBreakPoint === "small",
	});

	useEffect(() => {
		bsBreakpoints.init();
		setCurrentBreakPoint(bsBreakpoints.getCurrentBreakpoint());

		const handleBreakPoint = (event) => {
			setCurrentBreakPoint(event.detail);
		};

		window.addEventListener("new.bs.breakpoint", handleBreakPoint);

		return () => {
			window.removeEventListener("new.bs.breakpoint", handleBreakPoint);
		};
	}, []);

	return (
		<div>
			<PageSection bgClass="background-color">
				<ResponsivePageHeader centered={true} title="Clubs & Committees" />
				<p className={descriptionClasses}>
					NIBA is a centre of excellence where education is a journey of
					exploring both the self and the world around. It goes beyond the
					confines of classroom and curriculum. Different learning clubs like IT
					Club (Satya), Cultural Club (Shiva), Nature's Club (Sampad), Marketing
					Club (Sambhav), HR Club (Sampark), Finance Club (Nidhi),
					Entrepreneur's Club (Sangathak), Sports Club(Swasth), Teacher's Club
					(Sikshyak), Literature Club (Smaranika) are functioning at NIIS
					specifically to cater to the needs of the students/teachers in
					realizing their innate potential in different areas of interest and
					showcasing their talent.
				</p>
				<p className={descriptionClasses}>
					Apart from providing an avenue for students to showcase their immense
					talents, these clubs also encourage students to take the initiative in
					organizing events and set new standards of excellence. To quote
					Abraham Lincoln, these are the clubs "of the students, by the
					students, for the students". A brief overview on the clubs is provided
					to give a glimpse of the activity that NIISians pursue in spite of
					their hectic academic schedule.
				</p>
			</PageSection>
			{/* 1. Students Grievance Redressal Committee */}
            <PageSection bgClass="white">
                <ResponsivePageHeader centered={true} title="Students Grievance Redressal Committee" />
                <p className="mb-4">
                    The student Grievance Committee is constituted consisting of the following members 
                    to redress the grievances of the students for the academic session 2025-26 for UG/PG programmes.
                </p>
                <Table striped bordered hover responsive className="mb-5">
                    <thead>
                        <tr>
                            <th>Sl. No.</th>
                            <th>Name</th>
                            <th>Designation</th>
                            <th>Responsibility</th>
                        </tr>
                    </thead>
                    <tbody>
                        {[
                            ["01", "Dr. Himanshu Sekhar Moharana", "Principal", "Chairman"],
                            ["02", "Dr. Ajit Kumar Khatua", "Director", "Member"],
                            ["03", "Mr. Mrutyunjay Senapati", "Vice-Principal", "Member"],
                            ["04", "Dr. Dillip Kumar Mahapatra", "Asso. Professor CSE", "Member"],
                            ["05", "Ms. Suprava Samal", "Lect. Dept. of Civil Engg.", "Member"],
                            ["06", "Mr. Nihar Ranjan Panda", "HOD, Computer Science & Engg.", "Member"],
                            ["07", "Mrs. Sasmita Mishra", "Librarian, NIET, Chhatabar", "Member"],
                            ["08", "Mr. Pratishruti Pattnaik", "B. TECH, 5TH Semester, CSE", "Member (student)"],
                            ["09", "Mr. Ajatrishna Pradhan", "B. TECH, 5TH Semester, CIVIL", "Member (student)"],
                            ["10", "Mr. Satyabrata Dwari", "1ST Semester, MCA", "Member (student)"],
                            ["11", "Ms. Surabhi S Sahoo", "1ST Semester, MCA", "Member (student)"],
                            ["12", "Ms. Anupama Mallick", "Diploma 3rd sem, EE", "Member (student)"],
                            ["13", "Mr. Pravakar Bhoi", "Diploma 3rd sem, MECH", "Member (student)"],
                        ].map((row, i) => (
                            <tr key={i}>
                                {row.map((cell, j) => <td key={j}>{cell}</td>)}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </PageSection>

            {/* 2. Internal Complaint Committee */}
            <PageSection bgClass="background-color">
                <ResponsivePageHeader centered={true} title="Internal Complaint Committee" />
                <p className="mb-4">
                    Established as per Section 4 of AICTE (Gender sensitization, Prevention and Prohibition of Sexual Harassment) Regulations, 2016.
                </p>
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>Sl. No.</th>
                            <th>Name & Designation</th>
                            <th>Email / Mobile</th>
                            <th>Responsibilities</th>
                        </tr>
                    </thead>
                    <tbody>
                        {[
                            ["01", "Dr. Himanshu Sekhar Moharana", "dr.himanshu1215@gmail.com / 7978926949", "Chair Person"],
                            ["02", "Mr. Mrutyunjay Senapati (Vice-Principal)", "msenapati2010@gmail.com / 7978098460", "Member"],
                            ["03", "Mr. Ajit Kumar Khatua (Director)", "ajitkhatua69@gmail.com / 7978483669", "Member"],
                            ["04", "Dr. Dillip Kumar Mahapatra", "dkmahapatra655@gmail.com / 7978232097", "Member"],
                            ["05", "Ms. Aparna Samal (Lect. English)", "samalaparna690@gmail.com / 7319288841", "Member"],
                            ["06", "Mrs. Sasmita Mishra (Librarian)", "sasmitamishra.niet@gmail.com / 9437757518", "Member"],
                            ["07", "Ms Meghana Sahoo (B.Tech 5th Sem)", "B tech 5th semester, CSE", "Member (student)"],
                            ["08", "Ms. Saudamini Nayak (MCA 1st Sem)", "MCA, 1ST Semester", "Member (student)"],
                            ["09", "Ms. Anupama Mallick (Diploma 3rd Sem)", "Diploma 3rd Semester, Electrical Engg.", "Member (student)"],
                        ].map((row, i) => (
                            <tr key={i}>
                                {row.map((cell, j) => <td key={j}>{cell}</td>)}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </PageSection>

            {/* 3. SC/ST Committee */}
            <PageSection bgClass="white">
                <ResponsivePageHeader centered={true} title="SC/ST Committee" />
                <p className="mb-4">
                    Constituted for the session 2025-26 for UG/PG programs as per AICTE requirement.
                </p>
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>Sl. No.</th>
                            <th>Name</th>
                            <th>Designation</th>
                            <th>Mobile Number</th>
                        </tr>
                    </thead>
                    <tbody>
                        {[
                            ["01", "Dr. Himanshu Sekhar Moharana", "Principal", "7978926949"],
                            ["02", "Mr. Mrutyunjay Senapati", "Vice-Principal", "7978098460"],
                            ["03", "Ms. Pallishree Mohapatra", "Lect. Dept. of Chemistry", "8117015785"],
                            ["04", "Mr. Somanath Jena", "Dept. of Mechanical Engg.", "6371691874"],
                            ["05", "Ms. Suprava Samal", "Sr. Lecturer Dept. of Civil", "8895746263"],
                            ["06", "Mr. Rakesh Kumar Sahoo", "System Admin", "7008459266"],
                            ["07", "Mr. Deepak Kumar Behera", "B.Tech., 3rd Sem, CSE", "8984316794"],
                        ].map((row, i) => (
                            <tr key={i}>
                                {row.map((cell, j) => <td key={j}>{cell}</td>)}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </PageSection>

            {/* 4. Institution Industry Cell */}
            <PageSection bgClass="background-color">
                <ResponsivePageHeader centered={true} title="Institution Industry Cell" />
                <p className="mb-4">
                    Constituted for the session 2025-26 for UG/PG programmes as per AICTE requirement.
                </p>
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>Sl. No.</th>
                            <th>Name</th>
                            <th>Designation</th>
                            <th>Mobile Number</th>
                        </tr>
                    </thead>
                    <tbody>
                        {[
                            ["01", "Dr. Himanshu Sekhar Moharana", "Principal", "7978926949"],
                            ["02", "Mr. Mrutyunjay Senapati", "Vice-Principal", "7978098460"],
                            ["03", "Mr. Ajit Kumar Khatua", "Director", "7978483669"],
                            ["04", "Mr. Nihar Ranjan Panda", "HOD, CSE", "6371691874"],
                            ["05", "Er. Akshaya Kumar Jena", "MD, Swagat Boilers Pvt. Ltd.", "9439083127"],
                            ["06", "Mr. Rakesh Kumar Sahoo", "Head Electrical, Shree Balaji Ind.", "7008459266"],
                        ].map((row, i) => (
                            <tr key={i}>
                                {row.map((cell, j) => <td key={j}>{cell}</td>)}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </PageSection>

            {/* Existing Club Cards Section */}
            <PageSection bgClass="white">
                <Row>
                    {studentCellData.map((data, index) => (
                        <Col
                            md="4 mt-2"
                            className="d-flex align-items-stretch mb-4 mb-md-0"
                            key={"club-card-" + index}
                        >
                            <ClubCard {...data} />
                        </Col>
                    ))}
                </Row>
            </PageSection>
		</div>
	);
};

export default StudentCellResponsive;
